<template>
  <div class="rwd-margin">
    <template v-if="loadingData">
      <v-sheet width="100%" height="200" class="text-center pt-15">
        <v-progress-circular indeterminate color="grey" size="48" />
      </v-sheet>
    </template>
    <template v-else-if="!loadingData && !tickets.length">
      <h3 class="text-center ma-10 grey--text">
        {{ $t("group_seat_no_product") }}
      </h3>
    </template>
    <template v-else>
      <!-- <div>
        <v-divider class="mt-5 rwd-margin" />
        <v-row
          class="font-weight-bold text-nine py-3 rwd-margin"
          no-gutters
          v-if="!$vuetify.breakpoint.xs"
        >
          <v-col cols="9" sm="6" class="text-center py-3 px-4">{{ $t('orderlist_product_name')}}</v-col>
          <v-col cols="3" sm="3" class="text-center py-3">{{ $t('order_step_2_product_price')}}</v-col>
          <v-col cols="3" sm="3" class="text-center py-3 px-4">{{ $t('orderlist_product_count')}}</v-col>
        </v-row>
        <v-divider class="mb-0 rwd-margin" />
      </div> -->
      <template v-for="(ticket, i) in tickets">
        <v-row
          :key="`tickets-${i}`"
          class="py-1 py-md-4 rwd-margin"
          v-if="!ticket.hidden"
          no-gutters
          :class="{
            soldout:
              (ticket.productLimit &&
                !ticket.remain &&
                !ticket.count &&
                ticket.status === 'onsale') ||
              ['soldout', 'lock', 'over', 'unavailable'].includes(
                ticket.status
              ),
            'text-title': !$vuetify.breakpoint.xs
          }"
        >
          <v-col
            cols="9"
            sm="6"
            align-self="center"
            class="font-weight-medium py-3"
            :class="!$vuetify.breakpoint.xs ? 'pl-6 d-flex align-center' : ''"
            v-if="ticket.status !== 'hidden'"
          >
            {{ ticket.name }}
            <v-tooltip top max-width="260">
              <template v-slot:activator="{ on, attrs }">
                <span v-if="ticket.tips" v-bind="attrs" v-on="on">
                  <v-icon color="primary">mdi-information-outline</v-icon>
                </span>
              </template>
              <span>{{ ticket.tips }}</span>
            </v-tooltip>
            <span
              v-if="
                (ticket.productLimit &&
                  ['pending', 'over', 'lock'].indexOf(ticket.status) === -1 &&
                  ticket.remain <= 20) ||
                  ticket.status === 'soldout' ||
                  ticket.status === 'unavailable'
              "
              class="ml-1 d-inline-block text-eight font-weight-bold"
              :class="{
                'red--text': ticket.remain <= 20 && ticket.status !== 'soldout',
                'grey--text': ticket.status === 'soldout'
              }"
              >{{ $t("group_seat_remain") }}
              {{
                ticket.remain <= 0 || ticket.status === "unavailable"
                  ? 0
                  : ticket.remain
              }}
            </span>
            <v-chip
              outlined
              v-if="
                ticket.status === 'onsale' &&
                  (ticket.remain > 20 || !ticket.productLimit)
              "
              >{{ $t("order_step_1_hot_sale") }}</v-chip
            >
            <div v-if="$vuetify.breakpoint.xs">
              NT.
              {{
                ticket.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }}
            </div>
          </v-col>
          <v-col
            v-if="!$vuetify.breakpoint.xs"
            cols="3"
            sm="3"
            md="3"
            align-self="center"
            class="text-center"
            :class="{
              'px-4 font-weight-bold': !$vuetify.breakpoint.xs,
              'pl-2': $vuetify.breakpoint.xs
            }"
          >
            NT.
            {{ ticket.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </v-col>
          <v-col
            cols="3"
            sm="3"
            align-self="center"
            :class="$vuetify.breakpoint.xs ? 'text-right' : 'px-4 text-center'"
          >
            <span
              v-if="ticket.status === 'pending'"
              :class="
                `font-weight-bold${
                  !!ticket.saleStart ? '' : ' ml-1 disabled-text'
                }`
              "
            >
              <template v-if="ticket.saleStart">
                <div class="text-nine">
                  {{ formatDateString(ticket.saleStart) }}
                </div>
                <div class="text-nine">
                  {{
                    $t(
                      `group_seat_sale_start${
                        campaign.isLottery ? "_lottery" : ""
                      }`
                    )
                  }}
                </div>
              </template>
              <template v-else>{{ $t("session_table_pending") }}</template>
            </span>
            <span
              v-else-if="ticket.status === 'over'"
              class="ml-1 disabled-text"
              >{{
                $t(`session_table_end${campaign.isLottery ? "_lottery" : ""}`)
              }}
            </span>
            <span
              v-else-if="['restricted', 'lock'].includes(ticket.status)"
              class="ml-1 disabled-text"
              >{{
                $t(`group_seat_lock${campaign.isLottery ? "_lottery" : ""}`)
              }}
            </span>
            <span
              v-else-if="ticket.status === 'unavailable'"
              class="ml-1 disabled-text"
              >{{ $t("status_unavailable") }}
            </span>
            <!-- <span
              v-else-if="!!ticket.saleEnd && isOverSaleEndTime(ticket.saleEnd)"
              class="ml-1 disabled-text"
              >{{ $t('group_seat_sale_end') }}
            </span> -->
            <span
              v-else-if="
                ticket.status === 'soldout' ||
                  (ticket.productLimit && !ticket.remain && !ticket.count)
              "
              class="ml-1 disabled-text"
              >{{ $t("group_seat_soldout") }}
            </span>
            <div
              v-else
              class="count-button d-flex justify-space-between align-center"
              :class="$vuetify.breakpoint.xs ? 'ml-auto' : 'mx-auto'"
            >
              <v-btn
                fab
                depressed
                x-small
                @click="minusCount(i)"
                :color="canLess(i) ? 'light-primary-2' : 'grey-1'"
                :disabled="
                  ticket.count === 0 ||
                    ticket.status !== 'onsale' ||
                    ticket.status === 'lock'
                "
              >
                <v-icon :color="canLess(i) ? 'primary-1' : 'grey-3'">
                  mdi-minus
                </v-icon>
              </v-btn>
              <div>
                {{ ticket.count }}
              </div>
              <v-btn
                fab
                depressed
                x-small
                @click="addCount(i)"
                :color="
                  canAdd(i) &&
                  (!ticket.productLimit ||
                    (ticket.productLimit && ticket.remain > 0)) &&
                  ticket.status === 'onsale'
                    ? 'light-primary-2'
                    : 'grey-1'
                "
                :disabled="
                  (ticket.productLimit &&
                    (!ticket.remain || ticket.remain - ticket.unit < 0)) ||
                    ticket.status !== 'onsale' ||
                    ticket.status === 'lock' ||
                    (!campaign.pickUp.includes('none') &&
                      !isInPostLimit &&
                      totalTicket >= 4)
                "
              >
                <v-icon
                  :color="
                    canAdd(i) &&
                    (!ticket.productLimit ||
                      (ticket.productLimit && ticket.remain > 0)) &&
                    ticket.status === 'onsale'
                      ? 'primary-1'
                      : 'grey-3'
                  "
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <div v-if="!ticket.hidden" class="red-dash-divider rwd-margin" />
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Mixins from "./TicketMixins.vue";

export default {
  props: {
    refresh: Boolean,
    loading: Boolean,
    clear: Boolean,
    reselect: Boolean
  },
  mixins: [Mixins],
  data() {
    return {
      serialNumberErr: "",
      serialNumber: "",
      hasSerial: false,
      isSubmit: false,
      guarantee: false,
      tickets: [],
      hasSelect: false,
      panel: [],
      panelActive: false,
      currentArea: -1,
      totalTicket: 0
    };
  },
  computed: {
    ...mapGetters({
      areaAssignment: "order/areaAssignment",
      isPopState: "order/isPopState",
      campaign: "event/campaign",
      session: "session/sessionInfo",
      couldCulturePoint: "culturePoint/couldCulturePoint"
    }),
    seatAssignmentInProd() {
      if (this.session.ticketArea) {
        return (
          this.currentArea === -1 ||
          this.seatAreas[this.currentArea].seatAssignment
        );
      } else {
        return false;
      }
    }
  },
  watch: {
    async refresh(newVal, old) {
      if (newVal) {
        await this.productInit(true).then(() => {
          setTimeout(() => {
            this.$emit("refreshEnd");
            this.$emit("update", {
              selectedTickets: this.tickets.filter(t => t.count > 0),
              totalTicket: this.totalTicket,
              seatAssignmentInProd: this.seatAssignmentInProd
            });
          }, 500);
        });
      }
    },
    clear(newVal, oldVal) {
      if (newVal !== oldVal && newVal === true) {
        this.clearSelect();
        this.$emit("update", {
          selectedTickets: this.tickets.filter(t => t.count > 0),
          totalTicket: this.totalTicket,
          seatAssignmentInProd: this.seatAssignmentInProd
        });
      }
    },
    isPopState: {
      deep: true,
      handler: function(newVal, old) {
        if (old !== newVal && !newVal) {
          this.init();
        }
      }
    },
    reselect(newVal, old) {
      if (newVal && newVal !== old) {
        this.tickets = this.tickets.map(s => {
          if (s.count > 0) {
            s.remain += s.count;
          }
          s.count = 0;
          return s;
        });

        this.productInit(true);
        this.$forceUpdate();
      }
    }
  },
  mounted() {
    this.productInit();
  },
  methods: {
    ...mapActions({
      buyTickets: "order/buyTickets",
      setAreaAssignment: "order/setAreaAssignment",
      setSeatAssignment: "order/setSeatAssignment",
      setSelectedArea: "order/setSelectedArea",
      reserveTicket: "order/reserveTicket",
      setPopState: "order/setPopState",
      showDialog: "dialog/show",
      showLogIn: "login/show",
      logout: "user/logout",
      setCampaign: "event/setCampaign",
      setSession: "session/setSession",
      canCulturePoint: "culturePoint/canCulturePoint"
    })
  }
};
</script>

<style lang="scss">
@import "./ticket.scss";
</style>
